<template>
  <div>
    <el-card body-style="padding: 0;margin-top: 20px;">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="订单号" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入系统订单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="任务编号" prop="taskNum">
              <el-input v-model="queryForm.userName" placeholder="请输入任务编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="操作人" prop="optUser">
              <el-input v-model="queryForm.userName" placeholder="请输入操作人"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="交易类型" prop="status">
              <el-select v-model="queryForm.status" clearable placeholder="请选择交易类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="20">
          <el-col :span="5">
            <el-form-item label="账户类型" prop="status">
              <el-select v-model="queryForm.status" clearable placeholder="请选择账户类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                导出
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                :cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;">
        <el-table-column prop="dateTime" label="时间" width="100"/>
        <el-table-column prop="serialNumber" label="交易流水号" width="100"/>
        <el-table-column prop="userType" label="用户类型" />
        <el-table-column prop="b2cUsersId" label="用户账号" width="220"/>
        <el-table-column prop="serialTypeEnumStr" label="交易类型" />
        <el-table-column prop="orderId" label="订单编号" />
        <el-table-column prop="b2cTaskId" label="任务编号" />
        <el-table-column prop="money" label="金额" />
        <el-table-column prop="balanceMoney" label="余额" />
        <el-table-column prop="moneyChangeTypeStr" label="类型" />
        <el-table-column prop="AccountType" label="账户类型" />
        <el-table-column prop="remarks" label="备注" />
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {querycustomermdetail} from "../../api/b2cbusiness/b2c_customerinfo";

export default {
  name: "CustomerMoneyDetail",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryForm: {},
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.tableHeight = document.body.clientHeight -220;
    this.getData();
  },
  methods:{
    getData(){
      querycustomermdetail({userId:this.$route.query.userId}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>

</style>
